require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ru-pages-covid-19-update.json") })
        }
      }, "path---ru-pages-covid-19-update");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ru-pages-covid-19-update!./.cache/json/ru-pages-covid-19-update.json
// module id = 782
// module chunks = 231608221292675